
import React, { useEffect, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from "react-router-dom";
import ButtonBase from '@material-ui/core/ButtonBase';
import {
  TabsComponent,
  RadiosGroupComponent,
  CompletedDataComponent,
  Spinner
} from '../../../../../Components';
import { GetParams   } from '../../../../../Helper';
//import { ContactsVerticalTabsData } from '../../Common/OpenFileView/OpenFileUtilities/OpenFileData';
import { GetInquiryDetailsByIdService  } from '../../../../../Services';
import { ListingShortageVerticalTabsData } from './Sections' ;  

const parentTranslationPath = 'Inquires';
const translationPath = '';

export const ListingShortageProfileManagementView = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [activeInquiryData, setActiveInquiryData] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const [viewType, setViewType] = useState(1);
  const [completInquiry , setCompletInquiry] =  useState(false) ;
  const [reloadInquiryData , setReloadInquiryData] = useState(null) ;
  const [inquiryEmptyFields ,setInquiryEmptyFields ] = useState(null); 
  const activeItem = useSelector((state) => state.ActiveItemReducer);

  const [filterBy, setFilterBy] = useState({
    id: null,
    formType: null,
  });

  const pathName = window.location.pathname
  .split('/home/')[1]
  .split('/view')[0]
  .split('/')[0]; 


  const getInquiryDetails = useCallback(async (id) => {
    setIsLoading(true);
    const InquiryDetailsRes = await GetInquiryDetailsByIdService(id);
    if (!(InquiryDetailsRes && InquiryDetailsRes.status && InquiryDetailsRes.status !== 200)) {
        setActiveInquiryData(InquiryDetailsRes);
        setInquiryEmptyFields(InquiryDetailsRes && InquiryDetailsRes.inquiryJson && JSON.parse(InquiryDetailsRes.inquiryJson)); 

    } else {
        setActiveInquiryData(null);
    }
    setIsLoading(false);
  }, [completInquiry , reloadInquiryData]);


  useEffect(() => {
    const inquiryId = +GetParams('id');
    if (inquiryId) 
    getInquiryDetails(inquiryId);
  }, [getInquiryDetails]);


  const [formType, setformType] = useState(+GetParams('formType'));
  const [list, setList] = useState([]);


  const onTabChanged = (e, newTap) => {
    setActiveTab(newTap);
  };
  const onViewTypeChangedHandler = (event, newValue) => {
    setViewType(+newValue);
  };

  useEffect(() => {
    setFilterBy({
      formType: (GetParams('formType') && +GetParams('formType')) || null,
      id: (GetParams('id') && +GetParams('id')) || null,
    });
  }, []);

  return (
    <div className='contact-profile-wrapper view-wrapper'>
      <Spinner isActive={isLoading} isAbsolute />
      <div className='d-flex-v-center'>
       <ButtonBase
              className={`body-status btns c-success-light  px-4`} 
              onClick={()=>{}}
              disabled={!(activeInquiryData && activeInquiryData.inquiryStatus ==='Open')}
            >
              <span className='body-status c-primary'>
             { activeInquiryData && activeInquiryData.inquiryStatus}
              </span>
            </ButtonBase>
        <RadiosGroupComponent
          idRef='viewDataRef'
          data={[
            {
              key: 1,
              value: 'all-data',
            },
            {
              key: 2,
              value: 'missing-data',
            },
          ]}
          value={viewType}
          labelValue='view'
          labelInput='value'
          valueInput='key'
          themeClass='theme-line'
          parentTranslationPath={parentTranslationPath}
          translationPathForData={translationPath}
          translationPath={translationPath}
          onSelectedRadioChanged={onViewTypeChangedHandler}
        />
      </div>
      <TabsComponent
        data = {ListingShortageVerticalTabsData}
        labelInput='label'
        parentTranslationPath={parentTranslationPath}
        translationPath={translationPath}
        themeClasses='theme-solid'
        currentTab={activeTab}
        onTabChanged={onTabChanged}
        dynamicComponentProps={{
          id: filterBy.id,
          viewType,
          parentTranslationPath,
          translationPath,
          setActiveTab, 
          activeTab,
          activeInquiryData  , 
          setCompletInquiry , 
          setReloadInquiryData ,
          inquiryEmptyFields ,  

        }}
      />
    </div>
  );
};